/** Traductions shell layout / navigation (FR / AR) */
export const layoutShellFr = {
  login: 'Connexion',
  roleLogin: 'Code manager / employé',
  manager: 'Manager',
  managerAbbr: 'Mgr',
  showMenu: 'Afficher le menu',
  hideMenu: 'Masquer le menu',
  sidebarExpanded: 'Navigation étendue',
  sidebarCompact: 'Navigation compacte (icônes)',
  sidebarHidden: 'Navigation masquée',
  breadcrumbHome: 'Accueil',
  searchPages: 'Rechercher une page…',
  searchNoResults: 'Aucune page trouvée',
  searchShortcut: 'Ctrl+K',
  navAriaLabel: 'Navigation principale',
  employeeUnknown: 'Employé',
  cartItemsUnit: 'article(s)',
  cartTotalLabel: 'Total panier',
  workerDashboardTitle: 'POS',
  myReports: 'Rapports',
  notifications: 'Notifications',
  userOptions: 'Options utilisateur',
  connectionLogin: 'Connexion',
  pause: 'Pause',
  logout: 'Déconnexion',
  logoutHint: 'Retour à la page de connexion entreprise',
  printerConnected: 'Imprimante connectée',
  printerConnectedNamed: 'Imprimante connectée : {{name}}',
  printerRolesDetail: 'Rôles : {{detail}}',
  printerPartial: 'Imprimantes partielles',
  navKitchenStock: 'Cuisine (stock)',
  navCuisineMonitor: 'Moniteur cuisine',
  navPurchasesIngredients: 'Achats ingrédients',
  navInventur: 'Inventaire',
  navEmployees: 'Employés',
  navGroupCommerce: 'Commerce',
  navGroupStock: 'Stock',
  navGroupFinance: 'Finance',
  navGroupAdmin: 'Admin',
};

export const layoutShellAr = {
  login: 'تسجيل الدخول',
  roleLogin: 'كود المدير / الموظف',
  manager: 'المدير',
  managerAbbr: 'مدير',
  showMenu: 'إظهار القائمة',
  hideMenu: 'إخفاء القائمة',
  sidebarExpanded: 'قائمة موسعة',
  sidebarCompact: 'قائمة مدمجة (أيقونات)',
  sidebarHidden: 'القائمة مخفية',
  breadcrumbHome: 'الرئيسية',
  searchPages: 'البحث عن صفحة…',
  searchNoResults: 'لم يتم العثور على صفحات',
  searchShortcut: 'Ctrl+K',
  navAriaLabel: 'التنقل الرئيسي',
  employeeUnknown: 'غير محدد',
  cartItemsUnit: 'عنصر',
  cartTotalLabel: 'مجموع السلة',
  workerDashboardTitle: 'نقطة البيع',
  myReports: 'تقاريري',
  notifications: 'الإشعارات',
  userOptions: 'خيارات المستخدم',
  connectionLogin: 'تسجيل الدخول',
  pause: 'إيقاف مؤقت',
  logout: 'تسجيل الخروج',
  logoutHint: 'العودة إلى صفحة تسجيل دخول الشركة',
  printerConnected: 'الطابعة متصلة',
  printerConnectedNamed: 'الطابعة متصلة: {{name}}',
  printerRolesDetail: 'الأدوار: {{detail}}',
  printerPartial: 'طابعات جزئية',
  navKitchenStock: 'المطبخ (مخزون)',
  navCuisineMonitor: 'شاشة المطبخ',
  navPurchasesIngredients: 'مشتريات المكونات',
  navInventur: 'الجرد',
  navEmployees: 'الموظفون',
  navGroupCommerce: 'التجارة',
  navGroupStock: 'المخزون',
  navGroupFinance: 'المالية',
  navGroupAdmin: 'الإدارة',
};
